import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'kt_theme_mode_value';

  isDarkMode = signal(localStorage.getItem(this.STORAGE_KEY) === 'dark');

  constructor() {
    document.documentElement.setAttribute(
      'data-bs-theme',
      this.isDarkMode() ? 'dark' : 'light'
    );
  }

  toggle(): void {
    this.isDarkMode.update(v => !v);
    const theme = this.isDarkMode() ? 'dark' : 'light';
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem(this.STORAGE_KEY, theme);
  }
}